import { createPopupReducerAndActionCreators } from '@paragon/popup-state';

import type { PopupOptionsMap } from '../actions/popupActions';

export const { popupReducer: popup, showPopup } = createPopupReducerAndActionCreators<PopupOptionsMap>();
